import Cookie from 'js-cookie';

import config from '@/config/environment';

export function setToken(jwt: string) {
  Cookie.set('jwt', jwt, { expires: 365, domain: config.COOKIE_DOMAIN });
}

export const authorizationGuard = () => {
  const jwt: string = Cookie.get('jwt');

  if (!jwt) {
    window.location.replace(`${config.LOGIN_URL}`);
  }
  setToken(jwt);
};

export const logout = () => {
  Cookie.remove('jwt');
  localStorage.removeItem('inactiveModalDataRequest');
  window.location.replace(`${config.CLIENGO_APP_URL}/logout`);
};
